<template>
	<div class="product-categories-selection">
		<!-- Main Category -->
		<div class="form-group mb-3">
			<label v-if="label"><b>Product Category</b></label>
			<multiselect
				placeholder="Select Category"
				label="name"
				track-by="slug"
				v-model="category"
				:options="categories"
				:show-labels="false"
				:allow-empty="false"
				:loading="isFetchingCategories"
				:disabled="categories.length === 0"
				@select="onCategoryChange">
			</multiselect>
			<div class="error-messages text-danger" v-if="this.error">
				Kategori Utama Wajib Diisi
			</div>
		</div>
		<div class="row">
			<!-- Sub Category -->
			<div class="col-sm-6" v-if="!!category && subCategories.length > 0">
				<div class="form-group">
					<!-- <label><b>Product Sub-Category</b></label> -->
					<multiselect
						placeholder="Select Category"
						label="name"
						track-by="slug"
						v-model="subCategory"
						:options="subCategories"
						:show-labels="false"
						:allow-empty="false"
						:loading="isFetchingCategories"
						:disabled="subCategories.length === 0"
						@select="onCategoryChange">
					</multiselect>
				</div>
			</div>
			<!-- Sub Sub Category -->
			<div class="col-sm-6" v-if="!!subCategory && subSubCategories.length > 0">
				<div class="form-group">
					<!-- <label><b>Product Sub-Sub-Category</b></label> -->
					<multiselect
						placeholder="Select Category"
						label="name"
						track-by="slug"
						v-model="subSubCategory"
						:options="subSubCategories"
						:show-labels="false"
						:allow-empty="true"
						:loading="isFetchingCategories"
						:disabled="subSubCategories.length === 0"
						@select="onCategoryChange">
					</multiselect>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import productsApi from '../api/products';

export default {
	name: 'ProductCategory',
	props: {
		data: {
			type: Object,
		},
		label: {
			default: true,
			type: Boolean,
		},
		error: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			isFetchingCategories: false,
			categories: [],
			subCategories: [],
			subSubCategories: [],
			category: null,
			subCategory: null,
			subSubCategory: null,
		};
	},
	methods: {
		fetchCategories(type = 'category', parentId = null) {
			this.isFetchingCategories = true;
			const callback = (response) => {
				this.isFetchingCategories = false;
				const categories = response.data;
				if (type === 'category') {
					this.categories = categories;
				} else if (type === 'sub_category') {
					this.subCategories = categories;
				} else if (type === 'sub_sub_category') {
					this.subSubCategories = categories;
				}
			};
			const errorCallback = () => {
				this.isFetchingCategories = false;
			};
			productsApi.getCategories(parentId, callback, errorCallback);
		},
		onCategoryChange(category) {
			this.$emit('change', category);

			if (category.type === 'category') {
				this.subCategories = [];
				this.subSubCategories = [];
				this.subCategory = null;
				this.subSubCategory = null;
				this.fetchCategories('sub_category', category._id);
			} else if (category.type === 'sub_category') {
				this.subSubCategories = [];
				this.subSubCategory = null;
				this.fetchCategories('sub_sub_category', category._id);
			}
		},
	},
	created() {
		this.fetchCategories();
	},
	watch: {
		categories(categories) {
			const category = categories.find(category => category.slug === this.data.category_slug);
			if (category) {
				this.category = category;
			}
		},
		subCategories(categories) {
			const category = categories.find(category => category.slug === this.data.sub_category_slug);
			if (category) {
				this.subCategory = category;
			} else {
				this.subCategory = null;
			}
		},
		subSubCategories(categories) {
			const category = categories.find(category => category.slug === this.data.sub_sub_category_slug);
			if (category) {
				this.subSubCategory = category;
			} else {
				this.subSubCategory = null;
			}
		},
		category(category) {
			this.onCategoryChange(category);
		},
		subCategory(category) {
			if (category) {
				this.onCategoryChange(category);
			} else {
				const emptyCategory = {
					name: '',
					slug: '',
					type: 'sub_category',
				};
				this.$emit('change', emptyCategory);
			}
		},
		subSubCategory(subSubCategory) {
			if (!subSubCategory) {
				const emptyCategory = {
					name: '',
					slug: '',
					type: 'sub_sub_category',
				};
				this.$emit('change', emptyCategory);
			}
		},
	},
};
</script>
